import { CloseIcon } from 'assets/icons/CloseIcon'
import { Modal } from 'components/Modal/Modal'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import useModalClose from 'hooks/useModalClose'
import { CursorPointer, Flex } from 'styling/GlobalStyles'
import { OtherText, TitleText } from 'styling/Typography'
import { tokens } from 'styling/tokens'
import { IReceiptQcDetailModalProps } from 'types/inventorySupply.interface'
import { formatDateForDisplay } from 'utils/helpers'
import { formatSupplyGhs, RECEIPT_QC_META } from '../inventorySupplyDemoData'
import { receiptsOptions } from './receiptsData'
import {
  ReceiptDiscrepancyBanner,
  ReceiptQcGrid,
  ReceiptQcItem,
  ReceiptQcSection,
  ReceiptQcValueEm,
} from './ReceiptQcModal.styled'

export const ReceiptQcModal = ({ receipt, closeModal }: IReceiptQcDetailModalProps) => {
  useModalClose(closeModal)
  const meta = RECEIPT_QC_META[receipt.qc.result]

  return (
    <Modal black>
      <Flex column gap='0.5rem' width='100%'>
        <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
          <TitleText weight='bold'>{`Receipt ${receipt.receiptNo} — ${receipt.supplier.name}`}</TitleText>
          <CursorPointer onClick={closeModal}>
            <CloseIcon />
          </CursorPointer>
        </Flex>
        <Flex center gap='0.5rem' wrap>
          <StatusPill status={meta.tone} dot={receipt.qc.result === 'REJECTED'}>
            {`QC ${meta.label}`}
          </StatusPill>
          <OtherText grey>{receipt.itemsLabel}</OtherText>
        </Flex>
        <ReceiptQcGrid>
          <ReceiptQcItem>
            <OtherText grey>RECEIPT DATE</OtherText>
            <ReceiptQcValueEm>{formatDateForDisplay(receipt.receiptDate)}</ReceiptQcValueEm>
          </ReceiptQcItem>
          <ReceiptQcItem>
            <OtherText grey>LOCATION</OtherText>
            <ReceiptQcValueEm>{receipt.location.name}</ReceiptQcValueEm>
          </ReceiptQcItem>
          <ReceiptQcItem>
            <OtherText grey>RECEIPT STATUS</OtherText>
            <ReceiptQcValueEm>
              {receiptsOptions.find((o) => o.value === receipt.status)?.label || '—'}
            </ReceiptQcValueEm>
          </ReceiptQcItem>
          <ReceiptQcItem>
            <OtherText grey>AMOUNT</OtherText>
            <ReceiptQcValueEm>{formatSupplyGhs(receipt.totalAmount)}</ReceiptQcValueEm>
          </ReceiptQcItem>
        </ReceiptQcGrid>
        <ReceiptQcSection>
          <TitleText weight='bold'>Quality check</TitleText>
          <ReceiptQcGrid>
            <ReceiptQcItem>
              <OtherText grey>CHECKED BY</OtherText>
              <ReceiptQcValueEm>{receipt.qc.checkedBy}</ReceiptQcValueEm>
            </ReceiptQcItem>
            <ReceiptQcItem>
              <OtherText grey>CHECKED AT</OtherText>
              <ReceiptQcValueEm>{receipt.qc.checkedAt}</ReceiptQcValueEm>
            </ReceiptQcItem>
            <ReceiptQcItem>
              <OtherText grey>RESULT</OtherText>
              <Flex>
                <StatusPill status={meta.tone}>{meta.label}</StatusPill>
              </Flex>
            </ReceiptQcItem>
            <ReceiptQcItem>
              <OtherText grey>REASON</OtherText>
              <ReceiptQcValueEm
                $color={receipt.qc.result === 'REJECTED' ? tokens.status.danger.fg : undefined}
              >
                {receipt.qc.reason || '—'}
              </ReceiptQcValueEm>
            </ReceiptQcItem>
          </ReceiptQcGrid>
        </ReceiptQcSection>
        {receipt.discrepancy && (
          <ReceiptDiscrepancyBanner>
            <StatusPill status='danger' dot>
              Discrepancy
            </StatusPill>
            <OtherText color={tokens.status.danger.fg}>
              {`Ordered ${receipt.discrepancy.orderedQty ?? '—'} · received ${receipt.discrepancy.receivedQty} · Δ ${receipt.discrepancy.deltaQty} — ${receipt.discrepancy.note}`}
            </OtherText>
          </ReceiptDiscrepancyBanner>
        )}
      </Flex>
    </Modal>
  )
}
